<template>
  <div class="content">
    <div class="row">
      <template v-for="item in list">
        <specifications-details
          v-if="equipments[item]"
          :key="item"
          :details="equipments[item]"
          :item-limit="14"
          :title="getTitle(item)"
          class="col-12 col-sm-6 mb-3"
        />
      </template>
    </div>
  </div>
</template>

<script>
import SpecificationsDetails from './specifications-details';

export default {
  name: 'VehicleSpecifications',
  props: {
    aliases: {
      type: Object,
      default: () => ({}),
    },
    equipments: {
      type: Object,
      required: true,
    },
    list: {
      type: Array,
      default() {
        return Object.keys(this.equipments);
      },
    },
  },
  components: {
    SpecificationsDetails,
  },
  methods: {
    getTitle(specification) {
      return (this.aliases[specification] || specification).toUpperCase();
    },
  },
};
</script>
